export default defineNuxtPlugin((nuxtApp) => {
    const hydrationReady = useState<boolean>('hydration-ready', () => false);

    nuxtApp.hook('app:mounted', () => {
        hydrationReady.value = true;
    });
});
